import * as React from 'react'
import {
  WithStyles,
  Theme,
  createStyles,
  Typography,
  withStyles
} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import { IForm } from 'src/type/form/form'
import { IQuestion, QuestionType } from 'src/type/form/question'
import autobind from 'autobind-decorator'
import { formatDate } from 'src/core/i18n/date'
import { compose } from 'redux'
import { RootState } from 'src/core/redux/reducer'
import {connect} from 'react-redux'
import Btn from 'src/shared/Btn/Btn'

const styles = (t: Theme) => createStyles({
    questionLabel: {
        fontWeight: 'bold'
    },
    questionAnswer: {
        padding: `${t.spacing.unit * 1.5}px`,
        backgroundColor: 'rgba(237, 28, 36, 0.16)'
    },
    question: {
        margin:`${t.spacing.unit}px 0`
    },
    extensionQuestion: {
        marginLeft:`${t.spacing.unit * 3}px`,
        padding: `${t.spacing.unit}px 0 ${t.spacing.unit}px ${t.spacing.unit * 3}px`,
        borderLeft: '1px solid #ED1C24',
    },
    formContent: {
        margin: `${t.spacing.unit * 2}px 0`,
        padding: `${t.spacing.unit}px`,
        height: 'calc(100vh - 360px)',
        minHeight: '300px',
        overflow: 'auto'
    },
    formActions:{
        display: 'flex',
        justifyContent: 'flex-end'
    }
});

interface IProps  extends WithStyles<typeof styles>,
WithI18n,
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props>  {
    form: IForm,
    title?: string,
    close: any,
    questionsDispo?: string[],
    visibleQuestions: string | string[];
}

interface IState {
    listPossibilityIdDepDisponible: any;
}

class FormWithAnswer extends React.Component<IProps, IState> {
    state = {
        listPossibilityIdDepDisponible: null,
    };

    componentDidMount(){
        this.setState({ listPossibilityIdDepDisponible : this.getListPossibilityIdDepDisponible(this.props.form) })
    }

    render() {
        const { form, t, classes, close, visibleQuestions, title } = this.props;
        const { listPossibilityIdDepDisponible } = this.state;
        return(
            <>  
                <Typography variant="h6" align="center" gutterBottom>{title ? title : form.name}</Typography>    
                {form && listPossibilityIdDepDisponible !== null &&
                    <>
                        {visibleQuestions === "all" &&
                            <div className={classes.formContent}>
                                {
                                    form.sections.map(s => {
                                        return (
                                            <div key={`${s.id}-section`}>
                                                <header key={`${s.id}-section_header`}>
                                                    <Typography variant="subtitle1" align="center" key={`${s.id}-section_title`} gutterBottom>{s.description}</Typography>
                                                </header>
                                                {
                                                    this.allQuestionsRendering(s.questions)
                                                }
                                            </div>
                                        )
                                    })
                                }     
                            </div>  
                        }  
                        {visibleQuestions !== "all" &&
                            <div className={classes.formContent}>
                                {
                                    form.sections[0].questions.filter(q => visibleQuestions.includes(q.index.toString())).map(question => {
                                        return this.questionWithAnswerRendering(question)
                                    })
                                }
                            </div>
                        }      
                    </>
                }
                <div className={classes.formActions}>
                    <Btn
                        variant='contained'
                        color='primary'
                        onClick={close}
                    >
                        {t.close}
                    </Btn>
                </div>
            </>
        )
    }

    @autobind
    private allQuestionsRendering(questions: IQuestion[]){
        return questions.map(q => {
            return (
                <div key={`question-${q.id}-wpr`}>
                    {this.showQuestion(q) === true &&
                        this.questionWithAnswerRendering(q)
                    }
                </div>
            )
        });
    }

    @autobind
    private questionWithAnswerRendering(q: IQuestion){
        const {t, classes} = this.props;
        return (
            <div key={`question-${q.id}`} className={this.isExtensionQuestion(q) === true ? classes.question : classes.extensionQuestion}>
                <p key={`question-label-${q.id}`} className={classes.questionLabel} >
                    {q.label}
                </p>
                <p key={`question-answer-${q.id}`} className={classes.questionAnswer}>
                {(q.answers.length > 0 && q.question_type === QuestionType.DATE) &&
                    this.answerDateRendering(q.answers)
                }
                {(q.answers.length > 0 && q.question_type !== QuestionType.DATE && q.question_type !== QuestionType.DOCUMENT) &&
                    this.answerRendering(q.answers)
                }
                {q.answers.length === 0 &&
                    <Typography variant="body2">{t.formanswers_summary_no_answer}</Typography>
                }
                </p>
            </div>
        )
    }

    @autobind
    private answerRendering(answer: string[]){
        if(answer.length > 0){
            return answer.map((a, i) => {
                return <span key={`answer-${i}`}>{a}</span>
            })
        } else {
            return ''
        }
    }

    @autobind
    private answerDateRendering(answer: string[]){
        if(answer.length > 0){
            return answer.map((a, i) => {
                return <span key={`answer-${i}`}>{formatDate(new Date(a))}</span>
            })
        } else {
            return ''
        }
    }

    @autobind 
    private showQuestion(question: IQuestion): boolean {
        const {listPossibilityIdDepDisponible} = this.state
        return (question.possibility_id_dep === undefined || question.possibility_id_dep.length === 0) ? true : new Map(listPossibilityIdDepDisponible).has(question.possibility_id_dep);
    }

    @autobind 
    private isExtensionQuestion(question: IQuestion) {
        return (question.possibility_id_dep === undefined || question.possibility_id_dep.length === 0) ? true : false
    }

    private getListPossibilityIdDepDisponible = (form: IForm) => {
        const questionsTypeRS = this.getListQuestionsWithTypeRadioOrSelect( form.sections.map(section => section.questions).reduce((a,b) => a.concat(b)));
        return this.getListAnswerTypeRadioOrSelect(questionsTypeRS);
    }

    private getListQuestionsWithTypeRadioOrSelect = (questions: IQuestion[]) => {
        return questions.filter(q => q.question_type === 'RADIO' || q.question_type === 'SELECT');
    } 

    private getListAnswerTypeRadioOrSelect = (questionsTypeRS: IQuestion[]) => {
        const answers = new Map();
        if(questionsTypeRS !== undefined){
            questionsTypeRS.forEach(question => {
                question.possibilities.forEach(possibility => {
                    if(question.answers.length > 0 && question.answers[0].indexOf(possibility.label) !== -1 ){
                        answers.set(possibility.id, question.id);
                    }
                })
            });
        }
        return answers;
    }
}

const state2props = (state: RootState) => ({
});
  
const dispatch2props = dispatch => ({
});

export default compose(
    withI18n,
    withStyles(styles), 
    connect(state2props, dispatch2props)
)(FormWithAnswer)



// WEBPACK FOOTER //
// ./src/shared/FormArkea/FormWithAnswer.tsx